<template>
  <DatatableReportV3
    title="Purchase Orders"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import PurchaseOrderModalLink from "@/Reports/PurchaseOrderModalLink.vue";
import store from "@/vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        order: [[0, "desc"]],
        columns: [
          { data: "po_date", filterName: "po_date", title: "Created Date" },
          {
            data: "purchase_order_id",
            title: "PO"
          },
          {
            data: "status",
            filterName: "voided"
          },
          {
            data: "job"
          },
          { data: "customer" },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          { data: "location_name", title: "Location Name" },
          {
            data: "address",
            orderable: false
          },
          { data: "department", filterName: "department_id" },
          {
            data: "type",
            title: "Category",
            filterName: "po_type"
          },
          {
            data: "created_for",
            title: "For",
            filterName: "technician_id"
          },
          { data: "vendor", filterName: "vendor" },
          {
            data: "amount",
            searchable: false,
            className: "text-right"
          },
          {
            data: "description",
            className: "po-description-field"
          }
        ],
        vueComponents: [
          {
            rootId: "purchase-order-modal-link",
            component: PurchaseOrderModalLink,
            options: {
              store
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Purchase Orders" });
  }
};
</script>

<style lang="scss">
td.po-description-field {
  white-space: normal;
}
</style>
